<template>
  <div class="mt-4">
    <div class="footer">
      <ul class="footermenu mb-0">
        <li>
          <a href="/about">{{ $t('message.aboutUs') }}</a>
        </li>
        <li>
          <a href="/contact">{{ $t('message.contactUs') }}</a>
        </li>
        <li>
          <a href="/privacypolicy">{{ $t('message.privacyPolicy') }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageFooter"
};
</script>
